<mat-card appearance="outlined" class="step-card">
  <mat-card-header>
    <mat-card-title>
      {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.MEETING_INTEGRATION.TITLE' | translate }}
    </mat-card-title>
    <mat-card-subtitle class="subtitle">
      <p>
        {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.MEETING_INTEGRATION.DESCRIPTION' | translate }}
      </p>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <meeting-scheduler-integration-selection
      [initialSelection]="initialServiceSelection$ | async"
      (integrationSelected)="onIntegrationSelected($event)"
    ></meeting-scheduler-integration-selection>
    <ng-container *ngIf="selection$ | async as selection">
      <div *ngIf="!selection.isConnected" class="integration-connection-banner">
        <ng-container *ngIf="selection.service === zoom">
          <span class="connect-text">
            {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CONNECTIONS.CONNECT_ZOOM_TO_CONTINUE' | translate }}
          </span>
          <meeting-scheduler-connect-with-zoom-button [serviceKey]="serviceKey">
          </meeting-scheduler-connect-with-zoom-button>
        </ng-container>
        <ng-container *ngIf="selection.service === meet">
          <span class="connect-text">
            {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CONNECTIONS.CONNECT_GOOGLE_MEET_TO_CONTINUE' | translate }}
          </span>
          <meeting-scheduler-connect-with-google-button
            [serviceKey]="serviceKey"
          ></meeting-scheduler-connect-with-google-button>
        </ng-container>
        <ng-container *ngIf="selection.service === microsoft">
          <span class="connect-text">
            {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CONNECTIONS.CONNECT_MICROSOFT_TO_CONTINUE' | translate }}
          </span>
          <meeting-scheduler-connect-with-microsoft-button
            [serviceKey]="serviceKey"
          ></meeting-scheduler-connect-with-microsoft-button>
        </ng-container>
      </div>
    </ng-container>
  </mat-card-content>
  <ng-content select="mat-card-actions"></ng-content>
</mat-card>
